// Zillow listing submission action types
export const SUBMIT_LISTING = "SUBMIT_LISTING";
export const SUBMIT_LISTING_SUCCESS = "SUBMIT_LISTING_SUCCESS";
export const SUBMIT_LISTING_FAIL = "SUBMIT_LISTING_FAIL";
export const UPDATE_LISTING_IMPORT = "UPDATE_LISTING_IMPORT";

// Listing fetch action types
export const FETCH_LISTING = "FETCH_LISTING";
export const FETCH_LISTING_SUCCESS = "FETCH_LISTING_SUCCESS";
export const FETCH_LISTING_FAIL = "FETCH_LISTING_FAIL";

// Listing confirmation action types
export const CONFIRM_LISTING = "CONFIRM_LISTING";
export const CONFIRM_LISTING_SUCCESS = "CONFIRM_LISTING_SUCCESS";
export const CONFIRM_LISTING_FAIL = "CONFIRM_LISTING_FAIL";

// Listing cancellation action types
export const CANCEL_LISTING = "CANCEL_LISTING";
export const CANCEL_LISTING_SUCCESS = "CANCEL_LISTING_SUCCESS";
export const CANCEL_LISTING_FAIL = "CANCEL_LISTING_FAIL";

// Manual listing creation action types
export const CREATE_MANUAL_LISTING = "CREATE_MANUAL_LISTING";
export const CREATE_MANUAL_LISTING_SUCCESS = "CREATE_MANUAL_LISTING_SUCCESS";
export const CREATE_MANUAL_LISTING_FAIL = "CREATE_MANUAL_LISTING_FAIL";

// Image upload action types
export const UPLOAD_IMAGES = "UPLOAD_IMAGES";
export const UPLOAD_IMAGES_SUCCESS = "UPLOAD_IMAGES_SUCCESS";
export const UPLOAD_IMAGES_FAIL = "UPLOAD_IMAGES_FAIL";

// Input-document action types: PDFs the agent uploads for the analysis to
// READ (distinct from the appendix, whose pages ride the end of the package).
export const UPLOAD_INPUT_DOCUMENT = "UPLOAD_INPUT_DOCUMENT";
export const UPLOAD_INPUT_DOCUMENT_SUCCESS = "UPLOAD_INPUT_DOCUMENT_SUCCESS";
export const UPLOAD_INPUT_DOCUMENT_FAIL = "UPLOAD_INPUT_DOCUMENT_FAIL";

export const DELETE_INPUT_DOCUMENT = "DELETE_INPUT_DOCUMENT";
export const DELETE_INPUT_DOCUMENT_SUCCESS = "DELETE_INPUT_DOCUMENT_SUCCESS";
export const DELETE_INPUT_DOCUMENT_FAIL = "DELETE_INPUT_DOCUMENT_FAIL";

// Image deletion action types
export const DELETE_IMAGE = "DELETE_IMAGE";
export const DELETE_IMAGE_SUCCESS = "DELETE_IMAGE_SUCCESS";
export const DELETE_IMAGE_FAIL = "DELETE_IMAGE_FAIL";

// activeListingId is the UUID of the listing the user is currently
// working with. Most of the time the reducer sets it automatically from
// *_SUCCESS payloads, but these explicit actions let containers clear
// it on navigation (e.g., "Not your property?" link) or restore it
// from sessionStorage on app boot.
export const SET_ACTIVE_LISTING_ID = "SET_ACTIVE_LISTING_ID";
export const CLEAR_ACTIVE_LISTING_ID = "CLEAR_ACTIVE_LISTING_ID";
